/**
 * Scripts spécifiques à la page aftermarket.
 */
// Importer les javascripts généraux
import "./main";
// Importer les modules utiles à cette page
import Quicknav from "./modules/quicknav";
import MediaQuery from "./modules/media_query";
// Importer Swiper JS
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
// Importer Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
// Quicknav Aftermarket (sous-menus de la section aftermarket)
const quicknav = new Quicknav();
// Caroussel "flip cards" de la page aftermarket
const mediaQuery = new MediaQuery(); // Init l'objet qui permet de déterminer la taille de l'écran; afficher 4 cartes (desktop)
// init Swiper:
const swiperCards = new Swiper('#flip-cards-carrousel', {
    // configure Swiper to use modules
    modules: [Navigation],
    // Optional parameters
    loop: true,
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    slidesPerView: mediaQuery.handleScreenChange(),
});
// Animer les cartes "onclick"
var cartes = document.querySelectorAll('.flip-card__wrapper');
[...cartes].forEach((carte) => {
    carte.addEventListener('click', function (ev) {
        // Empêcher le retournement de la carte lorsqu'on clique sur le CTA
        const cta = carte.querySelector('a.diapo-carte__cta');
        if (cta == ev.target) {
            return;
        }
        // Appliquer le style qui fait tourner la carte
        carte.classList.toggle('flip-card__wrapper--is-flipped');
    });
});
